import React from 'react';
import css from '../styles/area-guardianship.css';

const { Component } = React;

class AreaGuardianship extends Component {
  render() {
    return (
      <div className="areas-area__wrapper areas-area__wrapper--hero areas-area__wrapper--guardianship">
        <div class="areas-area__hero">
        </div>
        <div class="areas-area__hero-text" data-aos="zoom-in">
          <h3>Guardianship, Limited Guardianship, Conservatorship</h3>
          <p>Sometimes it is necessary to seek court appointment of a guardian or conservator for a child or an incapacitated adult.  For example, this can happen due to the death of one or both parents of a minor child or the illness or injury of an adult.  I can guide and represent you through this complex process.</p>
        </div>
      </div>
    );
  }
}

export { AreaGuardianship };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/area-guardianship.js